// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MediaFilesController from "./media_files_controller"
import ModalController from "./modal_controller"
import PopoverController from "./popover_controller"
import MatchesController from "./matches_controller"
import TurboFrameHistoryController from "./turbo_frame_history_controller"
import ToastsController from "./toasts_controller"
import PresentersController from './presenters_controller'

import FilterController from "./filter_controller"
import DialogController from "./dialog_controller"
import DialogTriggerController from "./dialog_trigger_controller"
import PageFormController from "./page_form_controller"
import RevealController from "./reveal_controller"
import ParallaxController from "./parallax_controller"
import CountdownController from "./countdown_controller"
import UploaderController from "./uploader_controller"
import GalleryPreviewController from "./gallery_preview_controller"
import ImageFallbackController from "./image_fallback_controller"
import SecretController from "./secret_controller"
import LanpartySwitchController from "./lanparty_switch_controller"
import ImageTransparencyController from "./image_transparency_controller"
import DropdownSearchController from "./dropdown_search_controller"
import DropdownPortalController from "./dropdown_portal_controller"
import TournamentTreeController from "./tournament_tree_controller"
import ImageCropperController from "./image_cropper_controller"
import MapPoolController from "./map_pool_controller"
import NestedFormController from "./nested_form_controller"
import SelectController from "./select_controller"
import ClipboardController from "./clipboard_controller"
import ResetFormController from "./reset_form_controller"
import AutoSubmitController from "./auto_submit_controller"
import DismissibleController from "./dismissible_controller"
import LogFollowController from "./log_follow_controller"
import LogDataController from "./log_data_controller"
import DevToolbarController from "./dev_toolbar_controller"
import GameTagsController from "./game_tags_controller"
import SearchElapsedController from "./search_elapsed_controller"
import PlanEditorController from "./plan_editor_controller"
import SeatingPlanController from "./seating_plan_controller"
import TournamentFormController from "./tournament_form_controller"

import DynamicTabController from "./dynamic_tab_controller"
import DynamicTabHandleController from "./dynamic_tab_handle_controller"
import DynamicTabContentController from "./dynamic_tab_content_controller"

application.register("media_files", MediaFilesController)
application.register("modal", ModalController)
application.register("popover", PopoverController)
application.register("matches", MatchesController)
application.register("turbo-frame-history", TurboFrameHistoryController)
application.register("toast", ToastsController)
application.register("presenters", PresentersController)

application.register("filter", FilterController)
application.register("dialog", DialogController)
application.register("dialog-trigger", DialogTriggerController)
application.register("page-form", PageFormController)
application.register("reveal", RevealController)
application.register("parallax", ParallaxController)
application.register("countdown", CountdownController)
application.register("uploader", UploaderController)
application.register("gallery-preview", GalleryPreviewController)
application.register("image-fallback", ImageFallbackController)
application.register("secret", SecretController)
application.register("lanparty-switch", LanpartySwitchController)
application.register("image-transparency", ImageTransparencyController)
application.register("dropdown-search", DropdownSearchController)
application.register("dropdown-portal", DropdownPortalController)
application.register("tournament-tree", TournamentTreeController)
application.register("image-cropper", ImageCropperController)
application.register("map-pool", MapPoolController)
application.register("nested-form", NestedFormController)
application.register("select", SelectController)
application.register("clipboard", ClipboardController)
application.register("reset-form", ResetFormController)
application.register("auto-submit", AutoSubmitController)
application.register("dismissible", DismissibleController)
application.register("log-follow", LogFollowController)
application.register("log-data", LogDataController)
application.register("dev-toolbar", DevToolbarController)
application.register("game-tags", GameTagsController)
application.register("search-elapsed", SearchElapsedController)
application.register("plan-editor", PlanEditorController)
application.register("seating-plan", SeatingPlanController)
application.register("tournament-form", TournamentFormController)

application.register("dynamic-tab", DynamicTabController)
application.register("dynamic-tab-content", DynamicTabContentController)
application.register("dynamic-tab-handle", DynamicTabHandleController)